// Phase 21 · Listener CTA to request speaker role (audio rooms)
import React, { useState } from "react";
import { Mic } from "lucide-react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export default function SpeakerRequestButton({ room, onRequested }) {
    const [busy, setBusy] = useState(false);
    const [pending, setPending] = useState(false);

    if (room.room_type !== "audio") return null;
    if (room.viewer_role !== "listener") return null;

    const request = async () => {
        setBusy(true);
        try {
            const r = await fetch(`${API}/api/community/rooms/${room.id}/speaker-request`, {
                method: "POST", credentials: "include",
            });
            if (r.ok) {
                setPending(true);
                toast.success("Request sent — waiting for host approval");
                onRequested?.();
            } else if (r.status === 429) toast.error("Slow down");
            else toast.error("Request failed");
        } catch { toast.error("Network error"); }
        setBusy(false);
    };

    return (
        <button
            type="button"
            onClick={request}
            disabled={busy || pending}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition-all ${pending ? "bg-[#A3A3A3]/20 border border-[#A3A3A3]/40 text-[#A3A3A3]" : "bg-white text-neutral-900 hover:opacity-90"}`}
            data-testid="speaker-request-btn"
        >
            <Mic size={14} />
            {pending ? "Waiting for host…" : "Ask to speak"}
        </button>
    );
}
